type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  fillColor?: string;
};

const LongArrowUpIcon = (props: Props) => {
  const {
    width = '8',
    height = '10',
    viewBox = '0 0 8 10',
    fillColor = '#F3E9D7',
  } = props;
  
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={viewBox} fill="none">
      <path d="M4.28298 0.122198L7.88278 3.87208C7.95784 3.95026 8 4.05629 8 4.16686C8 4.27742 7.95784 4.38346 7.88278 4.46164C7.80773 4.53982 7.70594 4.58374 7.5998 4.58374C7.49366 4.58374 7.39187 4.53982 7.31681 4.46164L4.39998 1.42268V9.58335C4.39998 9.69385 4.35784 9.79983 4.28283 9.87797C4.20782 9.9561 4.10608 10 4 10C3.89392 10 3.79218 9.9561 3.71717 9.87797C3.64216 9.79983 3.60002 9.69385 3.60002 9.58335V1.42268L0.683184 4.46164C0.608132 4.53982 0.50634 4.58374 0.4002 4.58374C0.29406 4.58374 0.192268 4.53982 0.117216 4.46164C0.0421638 4.38346 0 4.27742 0 4.16686C0 4.05629 0.0421638 3.95026 0.117216 3.87208L3.71702 0.122198C3.75416 0.0834589 3.79828 0.0527268 3.84683 0.0317593C3.89539 0.0107918 3.94744 4.70727e-08 4 4.76995e-08C4.05256 4.83263e-08 4.10461 0.0107918 4.15317 0.0317593C4.20172 0.0527268 4.24584 0.083459 4.28298 0.122198Z" fill={fillColor}/>
    </svg>
  );
};

export default LongArrowUpIcon;
